<section class="content head">
  <div class="content-wrapper audit-list">    
    <div *ngIf="hasInitialAudits || auditFilter">
      <div class="audit-list__header">
        <h1>History Of {{auditTableData?.historyTitle}}</h1> 
        <span>There are {{auditTableData?.totalCount}} histories in this Audit.</span>
      </div>  
      <div class="audit-list__actions"></div>
    </div>    
  </div>
</section>
<section class="content" *ngIf="auditTableData">
  <div class="content-wrapper">
    <iaud-table [data]="auditTableData"
                [options]="auditTableOptions"
                [forceReloadEvent]="forceReloadEvent"
                [dataRefreshCallback]="reloadAuditListHistory.bind(this)"
                [dataDeleteCallback]="deleteData.bind(this)"
                [deleteTitle]="'Delete Audit'"
                [deleteText]="'Are you sure you want to delete ${data.auditTitle} audit?'">
    </iaud-table>
  </div>
</section>

<ng-template #findingsCellTemplate let-rowData="rowData">
  <div class="finding-cell">
    <span class="text">
      {{rowData.numberOfFindings}}
    </span>    
  </div>
</ng-template>

<ng-template #statusCellTemplate let-rowData="rowData">
  <iaud-audit-capa-status [status]="rowData.capaActivityStatus"></iaud-audit-capa-status>
</ng-template>

<ng-template #SMEsDetailTemplate let-detailData="detailData" let-detailOption="detailOption">
  <label [for]="detailOption.fieldName">{{detailOption.title}}</label>
  <p [id]="detailOption.fieldName" *ngFor="let sme of detailData.item[detailOption.fieldName]">
    {{ sme.fullName }}
  </p>
</ng-template>
